import React from 'react';
import cx from 'classnames';
import LabelText from '../LabelText';
import { slugify } from '../../helpers';
/**
 * The component manage the input/label IDs and names itself, however, you can override it
 * by passing your desired ID to this DropdownItem component.
 */
const DropdownItem = ({ id, isRefined, label, onChange, name, value, ...other }) => {
    const uniqueId = new Date().getTime();
    const slug = other.index && slugify(`${uniqueId}-${other.index}-${label.toLowerCase()}`);
    return (React.createElement("li", Object.assign({}, other, { className: cx('uil-bdbw-1 uil-bdbs-solid uil-bdc-grey-100 uil-bgc-white hover:uil-bgc-grey-100', isRefined && 'checked') }),
        React.createElement("label", { htmlFor: id || slug || label, title: label, className: "uil-d-flex uil-ai-center uil-w-100p uil-cursor-pointer" },
            React.createElement("input", { type: "checkbox", value: value, name: name || slug || label, id: id || slug || label, onChange: onChange, className: "uil-ml-8", checked: isRefined }),
            ' ',
            React.createElement(LabelText, { tag: "span", className: "uil-p-8 uil-d-inline-block uil-ov-hidden uil-ws-nowrap uil-to-ellipsis uil-w-100p uil-h-100p" }, label))));
};
export default DropdownItem;
